
import { getBookingState, setBookingStateProp } from "../../state.js";
import { setDropdown } from "../../ui/dropdown.js";
import { toggle } from "../../utils/ui-helpers.js";

// TODO: when introduce .env to this project, we can add an environment variable for pitchup-connect
const PITCHUP_API_URL = "https://pitch-connect-f57fd77b1bf0.herokuapp.com/";

const brandPlaceholderImages = {
    J: '/images/checkout/motorhomes/Just_go_Rainbow_UK_IE_Cutaway.png', // JustGO Brand code "J"
    N: '/images/checkout/motorhomes/Bunk_Campers_Grande_UK_IE_Cutaway.png', // Bunk campers brand code "N"
    A: '/images/checkout/motorhomes/Apollo_Duo_Plus_UK_IE_Cutaway.png', // TODO: get a placeholder for Apollo
    fallback: "https://res.cloudinary.com/dyltx4fuh/image/upload/q_75,c_pad,b_black,w_630,h_420/v1683632331/vyrk3qt9mfff90xwh363.jpg"
}

const motorhomeUI = {
    container : document.getElementById('atb-motorhome-extra-container'),
    messageBox: document.getElementById('atb-motorhome-results-message'),
    results   : document.getElementById('atb-motorhome-results')
}

let HAS_RUN = false;

export function init() {
    HAS_RUN = true;

    // Attach the motorhome extra change event 
    document.addEventListener('DOMContentLoaded', () => {
        console.log("Motorhome Rentals Extra DOM Content Loaded");
        const motorhomeExtraSelect = document.getElementById('atb-motorhome-rentals-extra');
        motorhomeExtraSelect.addEventListener('change', onMotorhomeExtraChange);            
    });    
}

// TODO: check to see if setting .disabled will work, wonder why I didn't do that
export function resetMotorhomeDropdown() {
    const resultsContainer     = motorhomeUI.container;
    const mhExtraDropdownInput = document.getElementById('atb-motorhome-rentals-extra');

    // Renable the motorhome dropdown by removing the disabled attribute    
    mhExtraDropdownInput.removeAttribute('disabled');
    setDropdown(mhExtraDropdownInput, "No", false);

    toggle(resultsContainer, false);
}


// TODO: Would be nice to bring the motorhome work into the state system
async function onMotorhomeExtraChange(event) {                
    const targetEl         = event.target;
    const selectedValue    = parseInt(targetEl.dataset.selectedId, 10);

    // block the user from changing the dropdown after
    targetEl.disabled = true;

    if (selectedValue === 0) {
        // Hide motorhome options
        toggle(motorhomeUI.container, false);
        return;
    }
    
    showLoadingSkeletons(motorhomeUI.results, 3);
    
    // Show motorhome options
    toggle(motorhomeUI.messageBox, false);
    toggle(motorhomeUI.container, true);    

    // const { 
    //     arrival_date: pickupDateTime,
    //     departure_date: returnDateTime
    // } = getBookingState;
                    
    const configData = document.getElementById('atb-config');
    
    const pickupDateTime = configData.getAttribute('data-arrival_date_full');
    const returnDateTime = configData.getAttribute('data-departure_date_full');

    const partyMemberValues = getAllVisiblePmValues();
    const numAdults   = partyMemberValues['adults'] || 0;
    const numChildren = partyMemberValues['children'] || 0;
    
    console.log("Fetching motorhomes for pickup:", pickupDateTime, "and return:", returnDateTime);

    const response = await fetchAvailableMotorhomes(
        pickupDateTime, 
        returnDateTime, 
        numAdults, 
        numChildren
    );

    // If there was an error - API is down or there's a branch closure across the selecte dates - show a message
    if (response.status == 400) {
        updateMotorhomeResults({
            title: "Oops!",
            message: response.data[0]
        });
        return;
    }

    // If no results were found, return early with an appropriate message
    if (!response.data || response.data.length === 0) {  
        updateMotorhomeResults({
            title: "Oops!",
            message: "Sorry - we couldn't find any available motorhomes for the dates you selected.",
        })
        targetEl.value = "Unavailable";
        return;
    }

    // If the request succeeded, build the motorhome results and update the UI
    const motorhomeResultsFrag = buildMotorhomeSectionFrag(response.data, returnDateTime, pickupDateTime);
    updateMotorhomeResults({
        title: "Showing Motorhomes for your selected dates",
        message: "We will include a link to the website in your booking confirmation email.",
        resultsHtmlFrag: motorhomeResultsFrag,
        show: true
    });
}
                

async function fetchAvailableMotorhomes(
    pickupDateTime, 
    returnDateTime, 
    adults = 2,
    children = 0,
    locationCode = 'LCY'
) {    
    const partySize = parseInt(adults, 10) + parseInt(children, 10);
    let response = fetch(PITCHUP_API_URL + 'thl-motorhomes/vehicle-availability', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
                pickupDateTime,
                returnDateTime,
                locationCode,
                size: partySize
            })
    }).then(res => res.json());

    return response;
}

function buildMotorhomeSectionFrag(motorhomeData, returnDateTime, pickupDateTime, resultLimit = 4) {

    // Create an empty doc frag - basically a dom tree outside of the de facto dom
    const resultFragment = document.createDocumentFragment();

    // We need day difference in order to calculate cost per day
    const dayDifference = Math.ceil((new Date(returnDateTime) - new Date(pickupDateTime)) / (1000 * 60 * 60 * 24));   

    // Build motorhome card HTML and append it to the empty dom frag - appending directly to the dom creates layout thrashing
    motorhomeData.forEach((vehicle, index) => {
        if (index >= resultLimit) return; // limit to first 3 vehicles
        const vehAvail = vehicle.VehAvails.VehAvail[0].VehAvailCore;

        const currencyCode         = vehAvail.TotalCharge.attributes.CurrencyCode;
        const estimatedTotalAmount = vehAvail.TotalCharge.attributes.EstimatedTotalAmount;       // This is the total amount with other products potentially included
        const totalAmount          = vehAvail.TotalCharge.attributes.RateTotalAmount;            // This is the total amount for the rental only
        
        const vehicleMakeModel = vehAvail.Vehicle.VehMakeModel.attributes.Name;
        const vehicleBrand     = vehicle.Vendor.attributes.CompanyShortName;
        const vehicleBrandCode = vehicle.Vendor.attributes.Code;
        const vehicleCapacity  = vehAvail.Vehicle.VehClass.attributes.Size;

        const vehicleImage = vehAvail.Vehicle.PictureURL || 
                            brandPlaceholderImages[vehicleBrandCode] || 
                            brandPlaceholderImages["fallback"];
        
        const costPerDay = totalAmount / dayDifference;
        const currencyFormatter = new Intl.NumberFormat('en-GB', {
            style: 'currency',
            currency: currencyCode
        });

        let specsForVehicle = [];

        vehAvail.Fees.Fee
            .filter(fee => fee.attributes.Purpose == "2")
            .forEach((fee, specIndex) => {
            // Note: purpose "2" = key spec, purpose "1" = charge to customer
            if (specIndex >= 3) return; // Limit to first 3 specs
            specsForVehicle.push(
                { 
                    "feeType"    : fee.attributes.FeeType,
                    "amount"     : fee.attributes.Amount,
                    "description": fee.attributes.Description,
                    "purpose"    : fee.attributes.Purpose
                }
            );
        });

        const cloneTemplate = buildMotorhomeExtraCard({
            index: index,
            imageUrl: vehicleImage,
            title: vehicleMakeModel,
            brand: vehicleBrand,
            capacity: vehicleCapacity,
            totalPrice: `${ currencyCode } ${ currencyFormatter.format(totalAmount) }`,
            costPerDay: `${ currencyCode } ${ currencyFormatter.format(costPerDay) }`,
            keySpecs: specsForVehicle,
        });

        resultFragment.appendChild(cloneTemplate);
    });

    return resultFragment;
}

function buildMotorhomeExtraCard({ 
    index, 
    imageUrl, 
    title, 
    brand,
    capacity, 
    costPerDay, 
    totalPrice, 
    keySpecs = [],
    isBestSeller = false
}) {
    const motorhomeTemplate = document.querySelector('#motorhome-card-template');
    const motorhomeClone    = motorhomeTemplate.content.cloneNode(true);

    // TODO: don't really like this repetition or using/renaming ids for every card - consider using data-attributes instead
    const vehicleImage         = motorhomeClone.querySelector('#thl-veh-image');
    const vehicleTitle         = motorhomeClone.querySelector('#thl-veh-title');
    const vehicleCapacity      = motorhomeClone.querySelector('#thl-veh-capacity');
    const vehiclePerDayPrice   = motorhomeClone.querySelector('#thl-veh-per-day-price');
    const vehicleTotalPrice    = motorhomeClone.querySelector('#thl-veh-total-price');
    const vehicleBadge         = motorhomeClone.querySelector('#thl-veh-badge');
    const brandLogoContainer   = motorhomeClone.querySelector('.brand-logo');
    const keySpecsContainer    = motorhomeClone.querySelector('.thl-key-specs');
    
    if (keySpecs.length > 0) {
        keySpecs.forEach(spec => {
            const specTemplate = document.querySelector('#key-spec-template');
            const specClone    = specTemplate.content.cloneNode(true);
            const specIcon     = specClone.querySelector('i');
            const specText     = specClone.querySelector('p');
            
            // Customize the icon and text based on fee type
            specText.textContent = spec.description;
            keySpecsContainer.appendChild(specClone);
        });
    } else {
        keySpecsContainer.classList.add('d-none');
    }

    // Generate and append the SVG icon
    const svgIcon = generateSvgIcon(brand.toLowerCase().split(' ').join('-'));
    if (svgIcon) {
        brandLogoContainer.appendChild(svgIcon);
        brandLogoContainer.classList.remove('d-none');
    }

    // Render badges if applicable
    if (isBestSeller) {
        vehicleBadge.textContent = 'Best Seller';
        vehicleBadge.classList.remove('d-none');
    } else {
        vehicleBadge.classList.add('d-none');
    }

    // Set unique IDs
    vehicleImage.id         = vehicleImage.id + '-' + index;
    vehicleTitle.id         = vehicleTitle.id + '-' + index;
    vehicleCapacity.id      = vehicleCapacity.id + '-' + index;
    vehiclePerDayPrice.id   = vehiclePerDayPrice.id + '-' + index;
    vehicleTotalPrice.id    = vehicleTotalPrice.id + '-' + index;

    vehicleImage.src               = imageUrl;
    vehicleTitle.textContent       = title;
    vehicleCapacity.textContent    = `Sleeps ${capacity}`;
    vehiclePerDayPrice.textContent = costPerDay;
    vehicleTotalPrice.textContent  = totalPrice;

    return motorhomeClone;
}


function generateSvgIcon(iconName) {
    // get the icon template, stored in motorhome-card.tpl
    const svgTemplate = document.querySelector(`#${iconName}-logo-template`);
    if (!svgTemplate) {
        console.error(`SVG icon template with id '${iconName}-logo-template' not found.`);
        return null;
    }

    const svg = svgTemplate.content.cloneNode(true);    
    return svg;
}


function showLoadingSkeletons(resultsContainer, count = 3) {
    console.log("Motorhome data loading event triggered");
    const motorhomeCardSkeletonTemplate = document.getElementById('motorhome-card-skeleton-template');

    // Clear previous results
    resultsContainer.innerHTML = '';

    // Show 3 skeleton cards while loading
    for (let i = 0; i < count; i++) {
        const skeletonClone = motorhomeCardSkeletonTemplate.content.cloneNode(true);
        resultsContainer.appendChild(skeletonClone);
    }
}

function updateMotorhomeResults({
    title,
    message,
    resultsHtmlFrag = null,
    show = true
}) {
    if (!motorhomeUI.container || !motorhomeUI.messageBox || !motorhomeUI.results) return;

    // Show / hide main container
    toggle(motorhomeUI.container, show);
    toggle(motorhomeUI.messageBox, true);

    // Update message content
    motorhomeUI.messageBox.innerHTML = `
        <h3 class="fw-semibold">${title}</h3>
        <p class="mb-0">${message}</p>
    `;

    motorhomeUI.results.replaceChildren();
    if (!resultsHtmlFrag) return;
    
    motorhomeUI.results.appendChild(resultsHtmlFrag);    

    // TODO: REMOVE ASAP
    document.getElementById('atb-config').setAttribute('data-has-run-motorhome-search', 1);
}